import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=83e4326a&"
import script from "./balance.vue?vue&type=script&lang=ts&"
export * from "./balance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports